import React from 'react'
import PropTypes from 'prop-types'
import { TableRow, TableCell } from '@mui/material'

const PrintDispatchAssetRow = ({ asset, label }) => (
  <TableRow>
    <TableCell sx={{ px: 0, fontSize: '1rem' }} align="left">
      {asset?.asset?.assetName}
    </TableCell>
    <TableCell sx={{ px: 0, fontSize: '1rem' }} align="left">
      {asset?.asset?.type}
    </TableCell>
    <TableCell sx={{ px: 0, fontSize: '1rem' }} align="left">
      {label}
    </TableCell>
  </TableRow>
)

PrintDispatchAssetRow.propTypes = {
  asset: PropTypes.object,
  label: PropTypes.string,
}

PrintDispatchAssetRow.defaultProps = {
  asset: {},
  label: '',
}

export default PrintDispatchAssetRow
